/**
 * Base URL for Stripe Account Link return/refresh (must be https, allow-listed in Stripe).
 * In Capacitor WebView, `window.location.origin` is often `capacitor://localhost`, which Stripe rejects.
 * Set VITE_PRD_PUBLIC_APP_URL to the public site origin (e.g. https://www.akihub.com.br).
 */
export function getStripeAccountLinkBaseUrl(): string {
  const fromEnv = (import.meta.env.VITE_PRD_PUBLIC_APP_URL ?? "").trim();
  if (fromEnv) {
    const withProto = /^https?:\/\//i.test(fromEnv) ? fromEnv : `https://${fromEnv}`;
    try {
      const u = new URL(withProto);
      return u.href.replace(/\/$/, "");
    } catch {
      return "";
    }
  }
  if (typeof window === "undefined") return "";
  const origin = window.location.origin;
  const bad =
    origin.startsWith("capacitor://") ||
    origin.startsWith("ionic://") ||
    origin === "null";
  if (bad) {
    return "";
  }
  try {
    return new URL(origin).origin;
  } catch {
    return "";
  }
}

/** Static page on the public site (not the SPA root) so Stripe return does not boot the app shell without tokens. */
const STRIPE_WALLET_RETURN_PATH = "stripe-wallet-return.html";

function stripeWalletReturnPathname(base: URL): string {
  const prefix = base.pathname.replace(/\/$/, "");
  return prefix ? `${prefix}/${STRIPE_WALLET_RETURN_PATH}` : `/${STRIPE_WALLET_RETURN_PATH}`;
}

export function buildStripeWalletReturnUrl(kind: "onboarding_done" | "refresh"): string {
  const raw = getStripeAccountLinkBaseUrl();
  if (!raw) return "";
  try {
    const u = new URL(raw.startsWith("http") ? raw : `https://${raw}`);
    u.pathname = stripeWalletReturnPathname(u);
    u.search = "";
    u.hash = "";
    u.searchParams.set("wallet", "1");
    if (kind === "onboarding_done") u.searchParams.set("onboarding", "done");
    else u.searchParams.set("refresh", "1");
    return u.toString();
  } catch {
    return "";
  }
}
